import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-6 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-bold text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10 flex flex-col items-center">
        <span className="w-20 h-20 flex items-center justify-center rounded-2xl bg-primary-50 mb-6">
          <i className="ri-emotion-sad-line text-3xl text-primary-400"></i>
        </span>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mb-2">
          Strona nie została znaleziona
        </h1>
        <p className="text-sm text-foreground-500 font-mono mb-6">{location.pathname}</p>
        <p className="text-base text-foreground-600 mb-8 max-w-md">
          Przepraszamy, ale strona, której szukasz, nie istnieje lub została przeniesiona.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line"></i>
          <span>Powrót na stronę główną</span>
        </Link>
      </div>
    </div>
  );
}